<template>
  <div class="container" :style="$store.state.equipment.height">
    <div class="content">
        <div class="header" style="border-bottom:1px solid #DCDFE6">
          <div class="item">
            <h4>订单编号</h4> 
            <span>{{orderDetail.orderNo}}</span>
          </div>
          <span 
            class="item"
            v-if="orderDetail.payStatus&&orderDetail.payStatus!=='payed'" 
            :style="{color:`${payStatusList[orderDetail.payStatus].color}`}"
          >
            {{payStatusList[orderDetail.payStatus].name}}
          </span>
        </div>
        <div class="item">
          <h4>批次名称</h4>
          <span>{{orderDetail.appraisalBatchName}}</span>
        </div>
        <div class="item">
          <h4>考试工种</h4>
          <span>{{orderDetail.occupation}}</span>
        </div>
        <div class="item">
          <h4>考试等级</h4>
          <span>{{orderDetail.skillLevel}}</span>
        </div>
        <div class="item">
          <h4>考试时间</h4>
          <span>{{$moment(orderDetail.examDate).format('YYYY-MM-DD HH:mm:ss')}}</span>
        </div>
        <div class="item">
          <h4>支付人数</h4>
          <span>{{orderDetail.signupNumber}}</span>
        </div>
        <div class="item" v-if="orderDetail.payStatus!=='unpaid'">
          <h4>付款方式</h4>
          <span>{{orderDetail.payTypeText}}</span>
        </div>
        <div class="item">
          <h4>付款金额</h4>
          <span>￥{{orderDetail.goodsPrice}}</span>
        </div>
        <div class="item" v-if="orderDetail.payStatus!=='unpaid'&&orderDetail.payTime">
          <h4>{{orderDetail.payStatus==='payed'?'付款时间':'提交时间'}}</h4>
          <span>{{$moment(orderDetail.payTime).format('yyyy-MM-DD HH:mm:ss')}}</span>
        </div>
        <div class="item" v-if="orderDetail.payStatus==='rejected'||orderDetail.payStatus==='timeOut'">
          <h4>驳回原因</h4>
          <span>{{orderDetail.rejectReason}}</span>
        </div>
        <div class="item" v-if="orderDetail.payStatus==='rejected'">
          <h4>剩余时间</h4>
          <van-count-down style="color:red" :time="duration(orderDetail.remainTime)" format="HH:mm:ss" />
          <span style="margin:-1px 0 0 5px">后订单自动关闭</span>
        </div>
        <template v-if="orderDetail.payStatus!=='unpaid'&&orderDetail.payType==='payByBankCard'">
          <div class="item">*支付凭证</div>
          <img style="margin-left:20px" @click="viewFlag=true" width="180px" :src="voucherUrl" alt="">
          <q-view-image v-if="viewFlag" :imgUrl="voucherUrl" @close="viewFlag=$event" ></q-view-image>
          <span 
            v-if="payVoucherPDF"
            class="previewText"
            
            @click="previewPDF"
          >
            点击查看
          </span>
          <q-preview-handout :url="voucherUrl" v-if="previewFlag" @close="close"></q-preview-handout>
        </template>
    </div>
  </div>
</template>
<script>
import QPreviewHandout from '@/view/confirm/compoment/previewHandout.vue'
import QViewImage from '@/view/organization/order/component/imageView.vue'
export default {
  components:{
    QViewImage,
    QPreviewHandout
  },
  data(){
    return{
      viewFlag: false,
      voucherUrl: '',
      previewFlag: false, //pfd预览弹窗
      orderDetail: {},
      payStatusList: {
        'payAuditing': {'name': '审核中', 'color': 'orange'},
        'rejected': {'name': '已驳回', 'color': 'red'},
        'timeOut': {'name': '订单超时已关闭', 'color': '#787878'}
      },
      payMethods: {
        'payByBankCard': '银行卡转账',
        'onlinePay': '线上支付',
        'wechat': '线上支付'
      },
    }
  },
  created: function (){
    this.getOrderDetail()
  },
  computed: {
    payVoucherPDF: function() {
      return this.orderDetail.payVoucher.toUpperCase().includes('.PDF')
    }
  },
  methods:  {
    getImagePath: function() {
      this.voucherUrl = this.$server.qxyRes + this.orderDetail.payVoucher
    },
    getOrderDetail: function() {
      let params = {
        id: this.$route.params.id
      }
      this.$http.get(`/registration/order/id`, { params }).then(res => {
        if(res.data.success){
          let list = res.data.data.order || {}
          list.remainTime = res.data.data.remainTime
          list.payTypeText = this.payMethods[list.payType]
          list.paymentText = list.payment.toFixed(2)
          this.orderDetail = list
          this.getImagePath()  //拼接图片
        }
      })
    },
    duration: function(time) {
      return this.$moment.duration(time).asSeconds()*1000
    },
    previewPDF: function() {
      this.previewFlag = true
      this.voucherUrl = this.$server.qxyRes + this.orderDetail.payVoucher
    },
    close: function() {
      this.previewFlag = false
    }
  },
  
}
</script>


<style scoped lang="less">
*{
  box-sizing: border-box;
}
.container {
	background: #F1F1F1;
}
.content{
	width: 100%;
	display: flex;
	flex-direction: column;
	background: white;
  .header{
    // padding: 10px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item{
    padding: 15px 30px;
    display: flex;
    align-items: center;
  }
  h4{
    font-size: 28px;
    color: #787878;
    font-weight: 100;
    margin-right: 20px;
  }
}
.previewText {
  color: #42A5F5;
  margin-left: 40px;
  cursor: pointer;
}
</style>